import axios from 'axios'
axios.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    return Promise.reject(error.response)
  }
)
import { Application } from '../helpers/app'

export async function apiRequest({
  URL,
  METHOD = 'GET',
  DATA,
  SHOW_ERROR_DETAILS = false
}) {
  const settings = {
    method: METHOD,
    url: URL
  }
  if (DATA && METHOD.toUpperCase() === 'GET') {
    settings.params = DATA
    // settings.params._token = Application.CSRF
  }
  if (DATA && METHOD.toUpperCase() === 'POST') {
    settings.data = DATA
    settings.data._token = Application.CSRF
    settings.dataType = 'json'
  }

  try {
    // TODO: Remove await!
    const response = await axios(settings)

    return response
  } catch (e) {
    if (SHOW_ERROR_DETAILS) {
      let listErrors = []
      let errorListText = '<br>'
      for (const key in e.data.errors) {
        const array = e.data.errors[key]
        listErrors = [...listErrors, ...array]
      }
      for (const error of listErrors) {
        errorListText += `<br><div>${error}</div>`
      }

      console.warn(e)

      const normalMessage = []

      if (e.data.message) {
        normalMessage.push(e.data.message)
      }
      if (listErrors.length > 0) {
        normalMessage.push(errorListText)
      }

      const techMessage = [
        `<pre style="line-height: 1.4; margin: 0;padding: 0">`,
        `API error<hr>`,
        `API URL: ${URL}<br>`,
        `API METHOD: ${METHOD}<br>`,
        `Error type: ${e.statusText}<br>`,
        `Error code: ${e.status}`,
        `</pre>`
      ]

      if (normalMessage.length > 0) {
        Application.error(`${normalMessage.join('')}`)
      } else {
        Application.error(`${techMessage.join('')}`)
      }
    }
    throw e
  }
}
